import { toDate as n } from "./toDate.js";
function r(e, o) {
  const t = n(e);
  return t.setSeconds(o), t;
}
export {
  r as default,
  r as setSeconds
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setSeconds.js
// module id = 1444
// module chunks = 67